<template lang="html">
  <div id="text-page">
    <section class="header-banners-section-s2">
    </section>

    <section class="container main-section" data-aos="fade-in" data-aos-duration="1000">
      <h1 class="mb-2 text-center page-title">Solicitud de afiliación y acuerdo de cláusulas</h1>

      <p>
        Entre: El Afiliado, Consumidor y Promotor (nombre y datos personales del solicitante), y FERNANDO PACHECO RANGEL, con domicilio en Avenida 5 Número 138, Local Comercial, Colonia Escuadrón 201, Código Postal 09060, Alcaldía Iztapalapa, Ciudad de México, en su carácter de representante de ECOMEXICO.
      </p>

      <br />
      <p>
        Mediante la presente, el Afiliado solicita su incorporación al sistema de afiliación como Consumidor Promotor y declara aceptar plenamente los términos establecidos en este acuerdo:
      </p>

      <br />
      <h5>CLÁUSULAS</h5>
      <h6>1. Capacidad legal y aceptación</h6>
      <p>
        Declaro ser mayor de edad y con capacidad para celebrar este acuerdo, el cual se considerará válido una vez aceptado por FERNANDO PACHECO RANGEL. Reconozco que el sistema no permite modificar afiliaciones ya registradas y que se protegen las relaciones creadas.
      </p>

      <br />
      <h6>2. Reconocimiento del plan de mercadotecnia</h6>
      <p>
        He leído y analizado el plan de mercadotecnia de e y lo reconozco como parte integral del presente acuerdo.
      </p>

      <br />
      <h6>3. Modificaciones</h6>
      <p>
        Entiendo que el plan de mercadotecnia y procedimientos pueden modificarse sin previo aviso. Me comprometo a mantenerme informado mediante los boletines oficiales.
      </p>

      <br />
      <h6>4. Promoción autorizada</h6>
      <p>
        Acepto que puedo promover el sistema únicamente bajo los lineamientos, políticas y materiales autorizados por la empresa.
      </p>

      <br />
      <h6>5. Transferencia del negocio</h6>
      <p>
        Reconozco que puedo transferir mi afiliación de forma voluntaria, en vida, y conforme a los procedimientos establecidos por la empresa.
      </p>

      <br />
      <h6>6. No existe relación laboral</h6>
      <p>
        No existe relación laboral
      </p>

      <br />
      <h6>7. Obligaciones fiscales</h6>
      <p>
        Acepto la retención de impuestos correspondiente a mis ingresos y me comprometo a entregar la documentación necesaria para efectos fiscales.
      </p>

      <br />
      <h6>8. Ingresos variables</h6>
      <p>
        Comprendo que mis ingresos dependerán del desempeño personal y de la actividad de mi red afiliada.
      </p>

      <br />
      <h6>9. Capacitación de afiliados</h6>
      <p>
        Si decido invitar a nuevos Afiliados, asumiré la responsabilidad de capacitarlos en el plan de mercadotecnia y productos.
      </p>

      <br />
      <h6>10. Prohibición sobre uso de marca</h6>
      <p>
        Queda prohibido utilizar el nombre o marcas de la empresa sin consentimiento escrito para fines de publicidad o promoción externa.
      </p>

      <br />
      <h6>11. Vigencia</h6>
      <p>
        Este acuerdo tiene vigencia indefinida, salvo que se incumpla alguna de sus cláusulas.
      </p>

      <br />
      <h6>12. Fallecimiento</h6>
      <p>
        Los beneficios económicos derivados del acuerdo se transferirán a la persona designada por el afiliado en su solicitud.
      </p>

      <br />
      <h6>13. Prohibiciones sobre beneficios exagerados</h6>
      <p>
        Se prohíbe ofrecer garantías de ingresos que no estén estipuladas oficialmente en el plan de mercadotecnia.
      </p>

      <br />
      <h6>14. Restricciones en espacios públicos</h6>
      <p>
        No se podrá exhibir el plan públicamente sin autorización escrita de la empresa.
      </p>

      <br />
      <h6>15. Compromiso con el plan</h6>
      <p>
        El Afiliado se compromete a cumplir con los pasos establecidos en el plan para acceder a los beneficios correspondientes.
      </p>

      <br />
      <h6>16. Consumo obligatorio vinculado a regalías</h6>
      <p>
        Al superar dos salarios mínimos mensuales en regalías, se autoriza la retención del consumo obligatorio para asegurar el pago de regalías futuras.
      </p>

      <br />
      <h6>17. Prohibición de reclutamiento cruzado</h6>
      <p>
        FERNANDO PACHECO RANGEL se reserva el derecho de cancelar el presente acuerdo si el Afiliado intenta reclutar a miembros activos para otras redes de mercadeo o para su propia red dentro del mismo sistema.
      </p>

      <br />
      <h6>17a. Inhabilitación por reclutamiento indebido</h6>
      <p>
        La persona retirada por esta causa perderá el derecho a reingresar como nuevo afiliado en el futuro.
      </p>
      <br />
      <ol>
        <li>
          <strong class="f-w-600">Conducta ética</strong><br />
          <p>
            El sistema requiere de altos estándares de ética y conducta. Queda prohibido emitir declaraciones falsas, comentarios peyorativos o incurrir en actos de engaño.
          </p>
        </li>
        <li>
          <strong class="f-w-600">Rescisión automática por incumplimiento</strong><br />
          <p>
            El incumplimiento de alguna cláusula resultará en la rescisión automática del acuerdo, con reserva de acciones legales y reclamo de daños y perjuicios.
          </p>
        </li>
        <li>
          <strong class="f-w-600">Jurisdicción</strong><br />
          <p>
            Para la interpretación y cumplimiento del presente acuerdo, las partes se someten a los tribunales competentes de la Ciudad de México, renunciando a cualquier otro fuero que pudiera corresponderles.
          </p>
        </li>
      </ol>

    </section>
  </div>
</template>

<script>
export default {
  data(){
    return{
      content: '',
    }
  },

  methods: {
    getContent: function(){
      axios.get(tools.url('/privacidad')).then((response)=>{
        this.content = response.data;;
      }).catch((error)=>{
        console.log(error);
      })
    }
  },

  beforeMount(){
    // this.getContent();
  }
}
</script>
